import * as React from 'react';
import { SurveyModel } from '../../models/survey.model';
import ReactMarkdown from 'react-markdown';

interface iProps {
    survey: SurveyModel,
}

class SurveyEndnote extends React.Component<iProps> {
    public render() {
        const endnote = this.props.survey.endNotes || '';

        return (
            <React.Fragment>
                <div className="row" >
                    <div className="col-sm-12">
                        <ReactMarkdown children={endnote} />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    private renderText(txt: string) {
        const txtArray = txt.split('\n');

        return (
            <>
            {txtArray.map((txt: string, index :number) => this.getParagraph(txt, index))}
            </>
        );
    }

    private getParagraph(txt: string, index: number) {
        return (
            <p key={index}>{txt}</p>
        );
    }
};

export default SurveyEndnote;
